module.exports = __webpack_public_path__ + "img/59.1cb4f698.gif";